<template>
  <div class="dataReport">
    <PanelHead title="数据报表" subtitle="DATA REPORT" :exportUrl="dataUrl">
      <el-button class="dataReport__custom-tag" size="mini" slot="customTag"></el-button>
    </PanelHead>
    <div class="formPanel">
      <h3 class="subTit"></h3>
      <ny-date-range v-model="date" @change="dateChange" :shortcut="true"></ny-date-range>
      <div class="selectBox">
        <span class="sel_lab_box">
          <label class="sel_lab" v-if="platform==='admin'|| platform==='agency'">广告主</label>
          <select-menu
            :list="adr.list"
            :current="adr"
            placeholder="请输入..."
            :filterable="true"
            v-if="platform==='admin'|| platform==='agency'"
            @changeSelectMenu="changeSelect"
            part="adr"
          ></select-menu>
        </span>
        <span class="sel_lab_box">
          <label class="sel_lab">广告组</label>
          <select-menu
            :list="order.list"
            :current="order"
            placeholder="请输入..."
            :filterable="true"
            @changeSelectMenu="changeSelect"
            part="order"
          ></select-menu>
        </span>
        <span class="sel_lab_box">
          <label class="sel_lab">计划</label>
          <select-menu
            :list="ad.list"
            :current="ad"
            placeholder="请输入..."
            :filterable="true"
            @changeSelectMenu="changeSelect"
            part="ad"
          ></select-menu>
        </span>
        <span class="sel_lab_box">
          <label class="sel_lab">创意</label>
          <select-menu
            :list="creative.list"
            :current="creative"
            placeholder="请输入..."
            :filterable="true"
            @changeSelectMenu="changeSelect"
            part="creative"
          ></select-menu>
        </span>
        <span class="sel_lab_box">
          <el-button @click="searchData">搜索</el-button>
        </span>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          class="panel-content__table"
          :page="page"
          @size-change="sizeChange"
          @current-change="currentChange"
          @cell-click="cellClick"
        >
          <el-table-column align="center" width="50" slot="firstColumn">
            <template slot-scope="scope">
              <i class="icon iconfont icon-barchart"></i>
            </template>
          </el-table-column>
        </ny-table>
      </div>
    </div>
    <el-collapse-transition>
      <div class="detailInfo" v-if="showBox">
        <ny-select
          :data="granularityMenu"
          v-model="granularity"
          :keyValue="['value', 'name']"
          @change="changeSelect2"
          type="granularity"
          placeholder="请选择"
          class="input_sm mb10 mt10 ml20"
        ></ny-select>
        <a class="button__export" :href="detailUrl">导出</a>
        <ny-table
          :page="detailPage"
          :pagination="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          :widthColumns="{ hour_time: 160 }"
          v-loading="loading"
        ></ny-table>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs'
import { mapActions, mapGetters } from 'vuex'
import { formatDate, getDiffDate } from '@/global/util/date'
import Page from '@/global/util/Page';
import { PanelHead, selectMenu, NyTable, NyDateRange, NySelect, Indicator } from '@/global/components'
export default {
  data () {
    return {
      options: {
        targets: [],
      },
      adr: {
        value: '', // 广告主value
        list: [] // 广告主列表
      },
      order: {
        value: '', // 广告组
        list: [] // 广告组列表
      },
      ad: {
        value: '', // 计划
        list: [] // 计划列表
      },
      creative: {
        list: [], // 创意列表
        value: '' // 创意
      },
      granularityMenu: [],
      granularity: '',
      loading: false,
      page: { // 总表数据
        headers: {},
        data: [],
        otherItem: 'name',
        pageSize: 10,
        pageIndex: 1,
        total: 0,
        loading: false
      },
      dataUrl: '',
      detailPage: new Page(), // 详情页数据
      detailUrl: '',
      date: [], // 日期插件当前日期
      showBox: false, // 是否展示详情数据的标识
      platform: '', // 当前广告平台名称
      selectType: '', // 详情表的标识
      clickRow: {} // 表格行点击时传的参数
    }
  },
  computed: {
    ...mapGetters({
      userid: 'login/userid'
    })
    /*
    dataUrl () {
      let data = {
        user_id: this.userid,
        ader_id: this.adr.value === '' ? '0' : this.adr.value,
        order_id: this.order.value === '' ? '0' : this.order.value,
        ad_id: this.ad.value === '' ? '0' : this.ad.value,
        start_time: this.date[0],
        end_time: this.date[1],
        page: this.page.pageIndex,
        perpage: this.page.pageSize,
        is_export: 1
      }
      return `${BASE_URL}/${this.platform}/data/list?${qs.stringify(data)}`
    }, */
    /* detailUrl () {
      let data = {
        start_time: this.date[0],
        end_time: this.date[1],
        user_id: this.userid,
        ader_id: this.clickRow.ader_id,
        ad_id: this.clickRow.ad_id ? this.clickRow.ad_id : 0,
        order_id: this.clickRow.order_id ? this.clickRow.order_id : 0,
        perpage: this.detailPage.pageSize,
        page: this.detailPage.currentPage,
        granularity: this.granularity,
        is_export: 1
      }
      return `${BASE_URL}/${this.platform}/data/detail?${qs.stringify(data)}`
    } */
  },
  created () {
    // this.userid = 1
    this.platform = this.$router.currentRoute.meta.platform; // 定义标识当前系统的常量
    let today = formatDate(new Date())
    this.date[0] = this.date[1] = today
    // 填充广告主下拉菜单
    this.getSelectMenu()
    this.getGranularity()
    this.getList()
  },
  methods: {
    ...mapActions(['dataReport/options', 'dataReport/table', 'dataReport/detail', 'dataReport/granularity', 'dataReport/getCustomTags']),
    dateChange (date) {
      this.showBox = false
      if (date) {
        this.date = date
      }
      this.getSelectMenu()
      this.getList()
    },
    changeSelect ({ select, part, type }) {
      if (part === 'adr') {
        this.order.value = ''
        this.ad.value = ''
        this.creative.value = ''
        this.adr.value !== '0' && this.getOptions(this.adr.value, '0', '0', (data) => {
          this.order.list = data
        })
      } else if (part === 'order') {
        this.ad.value = ''
        this.creative.value = ''
        this.order.value !== '0' && this.getOptions(this.adr.value, this.order.value, '0', (data) => {
          this.ad.list = data
        })
      } else if (part === 'ad') {
        this.creative.value = ''
        this.ad.value !== '0' && this.getOptions(this.adr.value, this.order.value, this.ad.value, (data) => {
          this.creative.list = data
        })
      }
    },
    changeSelect2 ({ value, type }) {
      if (type === 'granularity') {
        this.dayData({ row: this.clickRow })
      }
    },
    getGranularity () {
      this['dataReport/granularity']().then(data => {
        this.granularityMenu = data.data
        this.granularity = data.data.length > 0 ? data.data[0].value : ''
      })
    },
    getSelectMenu () {
      // 填充广告主下拉菜单
      if (this.platform === 'admin' || this.platform === 'agency') {
        this.getOptions('0', '0', '0', (data) => {
          this.adr.list = data
        })
      } else { // 填充计划下拉菜单
        this.getOptions('0', '0', '0', (data) => {
          this.order.list = data
        })
      }
    },
    getOptions (adrId, orderId, adId = '', callback) { // 获取下拉菜单数据
      const platformMap = {
        'agency': 'agency_id',
        'ka': 'ader_id',
        'admin': 'user_id',
        'ad-user': 'ader_id'
      }
      this['dataReport/options']({
        platform: this.platform,
        data: {
          start_time: this.date[0],
          end_time: this.date[1],
          ader_id: adrId,
          [platformMap[this.platform]]: this.userid,
          order_id: orderId === '' ? '0' : orderId,
          ad_id: adId === '' ? '0' : adId
        }      }).then(data => {
        if (data && data.code === 1) {
          callback(data.data)
        }
      })
    },
    getList () { // 获取表格数据
      this.page.loading = true
      let params = {
        user_id: this.userid,
        ader_id: this.adr.value === '' ? '0' : this.adr.value,
        order_id: this.order.value === '' ? '0' : this.order.value,
        ad_id: this.ad.value === '' ? '0' : this.ad.value,
        creative_id: this.creative.value === '' ? '0' : this.creative.value,
        start_time: this.date[0],
        end_time: this.date[1],
        page: this.page.pageIndex,
        perpage: this.page.pageSize,
        is_export: 0
      }
      this.$store.dispatch('dataReport/table', {
        platform: this.platform,
        data: params
      }).then((data) => {
        params.is_export = 1
        this.dataUrl = `${BASE_URL}/${this.platform}/data/list?${qs.stringify(params)}`
        this.page.loading = false
        this.page.header = data.data.header
        this.page.data = data.data.list
        this.page.total = data.data.count
        this.selectType = data.data.id_type
      })
    },
    sizeChange (page) { // 当表格显示条数发生变化是触发的函数
      this.showBox = false
      this.page.pageSize = page.pageSize;
      this.page.pageIndex = page.currentPage;
      this.getList();
    },
    currentChange (page) { // 当表格当前页码发生变化是触发的函数
      this.showBox = false
      this.page.pageIndex = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getList();
    },
    changePageSize ({ pageSize, currentPage }) {
      this.dayData({ currentPage, pageSize, row: this.clickRow })
    },
    searchData () {
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.detailPage.pageSize = 10
      this.detailPage.currentPage = 1
      this.getGranularity()
      this.showBox = false
      this.getList()
    },
    dayData ({ pageSize = this.detailPage.pageSize, currentPage = this.detailPage.currentPage, row } = {}) {
      let params = {
        start_time: this.date[0],
        end_time: this.date[1],
        user_id: this.userid,
        ader_id: row.ader_id ? row.ader_id : this.userid,
        ad_id: row.ad_id ? row.ad_id : 0,
        creative_id: row.creative_id ? row.creative_id : 0,
        order_id: row.order_id ? row.order_id : 0,
        perpage: pageSize,
        page: currentPage,
        granularity: this.granularity,
        is_export: 0
      }
      this['dataReport/detail']({
        platform: this.platform,
        data: params
      }).then(data => {
        if (data && data.code === 1) {
          params.is_export = 1
          this.detailUrl = `${BASE_URL}/${this.platform}/data/detail?${qs.stringify(params)}`
          this.detailPage.setPageData(
            {
              header: data.data.header,
              data: data.data.list,
              total: data.data.count
            },
            false
          );
        }
      })
    },
    cellClick ({ row, column, cell, event }) {
      this.showBox = true
      this.clickRow = row
      this.dayData({ row })
    },
  },
  components: {
    PanelHead,
    selectMenu,
    NyTable,
    NyDateRange,
    NySelect,
    Indicator
  }
}
</script>

<style lang="scss">
.dataReport {
  position: relative;
  .ny-date-range {
    margin: 27px 16px 8px 20px;
  }
  .mr0 {
    margin-right: 0 !important;
  }
  .selectBox {
    margin-left: 15px;
    line-height: 28px;
    .el-select {
      margin-right: 25px;
      width: 230px;
    }
  }
  .sel_lab_box {
    margin-top: 20px;
    display: inline-block;
  }
  .searchBox {
    width: 130px;
    height: 28px;
    margin-right: 30px;
    .el-input__inner {
      height: 28px;
    }
  }
  .sel_lab {
    margin-right: 15px;
    font-size: 14px;
  }
  .el-select {
    width: 118px;
    height: 28px;
    .el-input__inner {
      height: 28px;
    }
  }
  .tableBox {
    margin-top: 34px;
    .el-table {
      border-top: 1px solid #f1f5fc;
      border-bottom: 1px solid #f1f5fc;
    }
  }
  .success {
    color: #fff;
    background: #3dc1c4;
    border-color: #65cea7;
    padding: 6px 10px;
    margin-left: 5px;
  }
  .el-input__inner:focus {
    border-color: #2f6599;
  }
  .detailInfo {
    position: relative;
    margin-top: 44px;
    background: #fff;
    width: 100%;
    .ps-table {
      box-shadow: none;
    }
    .button__export {
      margin-top: -44px;
    }
  }
  .firstColumn {
    color: #0f1a23;
    cursor: pointer;
  }
  .icon {
    margin-left: 10px;
    color: #02bfc3;
  }
  .el-date-editor {
    margin: 27px 16px 28px 20px;
  }
  .dataReport__custom-tag{
    position: absolute;
    top: 9px;
    right: 88px;
    text-align: center;
    border-radius: 3px 3px;
    cursor: pointer;
  }
}
</style>
